export enum PosInfoSectionMode {
  CART,
  INSIGHT,
}
